module.exports = __webpack_public_path__ + "img/6.a09d6ad0.jpg";